import {
  GETNOTIFICATIONS,
  RESETNOTIFICATIONS
} from '@hobs/constants/notifications';
import { actionCreator } from './utils/utils';
import { formatFilter, tryGetODataString } from './odata';

const getODataParams = params => {
  let oDataParams = '';
  oDataParams = tryGetODataString(params);

  // Replaces '<guid> and </guid>' to allow to use guid
  const regExp = /('%3Cguid%3E)|(%3C%2Fguid%3E')/g;
  oDataParams = oDataParams.replace(regExp, '');

  return oDataParams;
};

export const getNotifications = (params = { skip: 0, take: 50 }) => {
  if (params.quickSearch) {
    params = { ...params, filter: formatFilter(params.quickSearch) };
  }

  let oDataParams = '';
  const selectedFields = [
    'ServiceRequestId',
    'RequestNumber',
    'IndicationDescription',
    'LastChangeDate'
  ].join(',');

  if (params.skip === 0 && params.take === 0) {
    params = { ...params, take: 50 }; // ERR_HTTP2_PROTOCOL_ERROR if take is 0

    oDataParams = getODataParams(params);

    return dispatch => {
      dispatch({
        type: RESETNOTIFICATIONS.SUCCESS
      });
      actionCreator(
        `NotificationsQuery?$count=true&${oDataParams}&$select=${selectedFields}`,
        GETNOTIFICATIONS,
        { method: 'GET' }
      )(dispatch);
    };
  } else {
    oDataParams = getODataParams(params);

    return actionCreator(
      `NotificationsQuery?$count=true&${oDataParams}&$select=${selectedFields}`,
      GETNOTIFICATIONS,
      { method: 'GET' }
    );
  }
};
